import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://nveqrjooxjdpedrxitjj.supabase.co';
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im52ZXFyam9veGpkcGVkcnhpdGpqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQwOTU5ODgsImV4cCI6MjA2OTY3MTk4OH0.NPfAlH2l1o03RxsE0TePQUdnqIII2KEqebDElrZkyUw';

export const supabase = createClient(supabaseUrl, supabaseKey);

export default supabase